import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import {
  BodyCardSubtitle,
  BodyCardTitle,
} from "components/CardTypography/styles";
import { PaperStyles } from "components/Paper/index.style";
import { breakpoints } from "styles/utils";

const ContainerCard = styled(PaperStyles)`
  padding: 20px 0px;
  border-radius: 12px;
  margin-inline: 16px;

  @media (min-width: ${breakpoints.medium}) {
    padding: 30px 0px;
  }
`;

const HeaderCard = styled.div<{ backgroundColor?: string | undefined }>`
  background-color: ${(props) => props.backgroundColor};
  display: flex;
  justify-content: center;
  padding: 8px 0px;

  @media (min-width: ${breakpoints.medium}) {
    padding: 20px 0px;
  }
`;

const BodyCard = styled.div`
  padding: 16px 8px;
  @media (min-width: ${breakpoints.small}) {
    padding: 16px 24px;
  }
`;

const WrapperInnerCard = styled(PaperStyles)`
  margin-top: 24px;
  padding: 32px 4px;

  @media (min-width: ${breakpoints.medium}) {
    padding: 32px 16px !important;
    margin-top: 35px !important;
  }

  @media (min-width: ${breakpoints.large}) {
    padding: 50px 60px !important;
  }
`;

const WrapperNoProduct = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  @media (min-width: ${breakpoints.medium}) {
    margin: 50px 16px;
  }
  @media (min-width: ${breakpoints.large}) {
    justify-content: center;
    margin: 85px auto;
    max-width: 800px;
  }
`;

const HelpStepImg = styled.img`
  max-width: 100%;
  height: auto;
  display: none;
  @media (min-width: ${breakpoints.large}) {
    display: block;
  }
`
const HelpStepContainer = styled.div<{
  invert?: boolean;
}>`
  display: flex;
  gap: 12px;
  align-items: center;
  @media (min-width: ${breakpoints.large}) {
    flex-direction: ${props => props.invert ? 'row-reverse' : 'row'};
  }
`

const Link = styled.a`
  color: #15997B;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`;

function Help() {
  return (
    <ContainerCard noPadding elevation={2}>
      <HeaderCard backgroundColor={"#15997B"}>
        <Typography
          variant="body2"
          align="center"
          variantMapping={{
            h4: "h1",
          }}
          style={{
            fontWeight: "bold",
            color: "#fff",
          }}
        >
          Kaspersky / Ajuda
        </Typography>
      </HeaderCard>
      <BodyCard>
        <BodyCardTitle variant="h1">
          Dúvidas de Ativação e instalação do produto?
        </BodyCardTitle>

        <WrapperInnerCard noPadding noMargin backgroundColor="#F5F5F5">
          <WrapperNoProduct>
            <ul style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <li>
                <BodyCardSubtitle variant="h2" align="center" style={{
                  display: "grid",
                  gridTemplateColumns: "min-content 1fr",
                  gap: "12px",
                  textAlign: "left",
                  alignItems: "center",
                }}>
                  <div style={{ fontWeight: "bold", fontSize: "36px" }}>
                    1.
                  </div>
                  <HelpStepContainer>
                    <div>
                      Acesse o site:  <Link href="https://my.kaspersky.com" target="_blank" rel="noreferrer">https://my.kaspersky.com</Link>
                      <br />
                      Faça o login em sua conta ou 
                                          registre-se para ativar seus produtos
                    </div>
                    <HelpStepImg
                      src="/images/step1.png"
                      alt="Ajuda"
                      style={{
                        width: "100%",
                        maxWidth: "400px",
                        margin: "0 auto",
                      }}
                    />
                  </HelpStepContainer>
                </BodyCardSubtitle>
              </li>
              <li>
                <BodyCardSubtitle variant="h2" align="center" style={{
                  display: "grid",
                  gridTemplateColumns: "min-content 1fr",
                  gap: "12px",
                  textAlign: "left",
                  alignItems: "center",

                }}>
                  <div style={{ fontWeight: "bold", fontSize: "36px" }}>
                    2.
                  </div>
                  <HelpStepContainer invert>
                    <div>
                      Na aba assinaturas, adicione o código do produto
                    </div>
                    <HelpStepImg
                      src="/images/step2.png"
                      alt="Ajuda"
                      style={{
                        width: "100%",
                        maxWidth: "400px",
                        margin: "0 auto",
                      }}
                    />
                  </HelpStepContainer>
                </BodyCardSubtitle>
              </li>
              <li>
                <BodyCardSubtitle variant="h2" align="center" style={{
                  display: "grid",
                  gridTemplateColumns: "min-content 1fr",
                  gap: "12px",
                  textAlign: "left",
                  alignItems: "center",

                }}>
                  <div style={{ fontWeight: "bold", fontSize: "36px" }}>
                    3.
                  </div>
                  <HelpStepContainer >
                    <div>
                      Após a instalação, seu produto estará ativado! Aproveite toda segurança e tranquilidade de usar Kaspersky!
                    </div>
                    <HelpStepImg
                      src="/images/step3.png"
                      alt="Ajuda"
                      style={{
                        width: "100%",
                        maxWidth: "400px",
                        margin: "0 auto",
                      }}
                    />
                  </HelpStepContainer>
                </BodyCardSubtitle>
              </li>
            </ul>

            <BodyCardSubtitle variant="h2" align="center">
              Base de Conhecimento Kaspersky para Dispositivos móveis e
              domésticos:
              <div>
                <Link
                  href="https://support.kaspersky.com.br/consumer"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://support.kaspersky.com.br/consumer
                </Link>
              </div>
            </BodyCardSubtitle>
            <BodyCardSubtitle variant="h2" align="center">
              Suporte para Produtos Domésticos ou Móveis:
              <div>
                <Link
                  href="https://support.kaspersky.com.br/consumer"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://support.kaspersky.com.br/b2c/BR
                </Link>
              </div>
            </BodyCardSubtitle>
            <BodyCardSubtitle variant="h2" align="center">
              Dúvidas sobre ativação de licença ou uso de nossa plataforma
              <div>
                QueroUmAntivirus, envie email para:
                <div>
                  <Link href="mailto:queroumantivirus@itailers.com.br">
                    queroumantivirus@itailers.com.br
                  </Link>
                </div>
              </div>
            </BodyCardSubtitle>
          </WrapperNoProduct>
        </WrapperInnerCard>
      </BodyCard>
    </ContainerCard>
  );
}

export default Help;
